import { useState } from "react";
import Subsection from "../Subsection";
import styles from "./HundredsOfCities.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import HundredsContent from "./HundredsContent";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";

const HundredsOfCities = ({
  isDesktop = false,
  title,
  withTabs = true,
  customCities = null,
  customCountries = null,
  customList = null,
}: {
  isDesktop?: boolean;
  title?: string;
  withTabs?: boolean;
  customCities?: Array<{ name: string; link: string }> | null;
  customCountries?: Array<{ name: string; link: string }> | null;
  customList?: Array<{ name: string; canonical_name: string; parent_name?: string }> | null;
}) => {
  const { t } = useTranslationHook();
  const { isAbove } = useResponsiveness();
  const isAboveMD = isAbove(SCREEN_SIZE.MD, false);
  const showForDesktop = isDesktop && isAboveMD;
  const [activeTab, setActiveTab] = useState<"cities" | "countries">("cities");

  const processedCustomList = customList?.length
    ? customList.map((item) => ({
        name: item?.name || "",
        link: item?.canonical_name || "",
      }))
    : null;

  const finalCustomCities = processedCustomList || customCities;
  const finalCustomCountries = customCountries;

  const heading = title || t("home.hundredsofcities.citiesheading");

  return (
    <Subsection titleH2 title={heading} subtitleH4 isDesktop={showForDesktop}>
      <div className={styles.hundredsOfCitiesContainer}>
        {withTabs && (
          <div className={styles.tabContainer}>
            <button
              className={`${styles.tab} ${activeTab === "cities" ? styles.activeTab : ""}`}
              onClick={() => setActiveTab("cities")}
              type="button"
            >
              {t("home.hundredsofcities.cities")}
            </button>
            <button
              className={`${styles.tab} ${activeTab === "countries" ? styles.activeTab : ""}`}
              onClick={() => setActiveTab("countries")}
              type="button"
            >
              {t("home.hundredsofcities.countries")}
            </button>
          </div>
        )}
        <HundredsContent
          isDesktop={isDesktop}
          activeTab={activeTab}
          customCities={finalCustomCities}
          customCountries={finalCustomCountries}
          showTabs={withTabs}
        />
      </div>
    </Subsection>
  );
};

export default wrapperHOC(HundredsOfCities, {
  componentName: "HundredsOfCities-Home",
  showForChina: true,
  showForMiniProgram: false,
  showForApp: false,
});
